// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__iL6qc","title":"Info_title__6iG2X","links":"Info_links__ZCj5Y","link":"Info_link__2-ttG","logo":"Info_logo__TICze"};